import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import de from './de.json';

const isDev = process.env.NODE_ENV === 'development';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
  },
  lng: isDev ? 'en' : 'de',
  fallbackLng: 'en',
  debug: isDev,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
